import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * EN | हिं toggle — rulebook §1 "Ek click me Hindi" (ticket 2.2).
 *
 * Sirf UI ke labels badalte hain; product ke naam English hi rehte hain,
 * kyunki mandi me log wahi naam bolte hain. Chunav browser me yaad rehta hai
 * (localStorage), taki agli baar wahi bhasha khule.
 */
const STORAGE_KEY = "ci_lang";

export interface LanguageToggleProps {
  className?: string;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState<string>(
    i18n.language && i18n.language.startsWith("hi") ? "hi" : "en"
  );

  useEffect(() => {
    let saved: string | null = null;
    try {
      saved = window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      saved = null;
    }
    if (saved === "hi" || saved === "en") {
      setLang(saved);
      i18n.changeLanguage(saved);
      document.documentElement.lang = saved;
    }
    // sirf ek baar, mount par
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pick = (next: string) => {
    if (next === lang) return;
    setLang(next);
    i18n.changeLanguage(next);
    document.documentElement.lang = next;
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      // private window me localStorage band ho sakta hai - toggle phir bhi chale
    }
  };

  const base = "rounded-[3px] px-2 py-[3px] text-[12.5px] leading-none transition";

  return (
    <div
      role="group"
      aria-label="Language"
      className={`flex items-center rounded-[4px] bg-ci-striptoggle p-[2px] ${className}`}
    >
      <button
        type="button"
        onClick={() => pick("en")}
        aria-pressed={lang === "en"}
        className={`${base} ${
          lang === "en"
            ? "bg-white font-semibold text-ci-navy"
            : "text-ci-stripfg hover:text-white"
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => pick("hi")}
        aria-pressed={lang === "hi"}
        className={`${base} font-hindi ${
          lang === "hi"
            ? "bg-white font-semibold text-ci-navy"
            : "text-ci-stripfg hover:text-white"
        }`}
      >
        हिं
      </button>
    </div>
  );
};

export default LanguageToggle;
